import { MultiCheckboxFilterOption } from '../../../FilterResultsManager/options/types';
import { MultiSelectCheckbox } from '../../../FilterResultsManager/components';

export const config: MultiCheckboxFilterOption = {
  id: 'jaxGeneDrugEvidence.filters.responseType',
  title: {
    id: 'jaxGeneDrugEvidence.filters.responseType',
    defaultMessage: 'Response Type',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'response_type',
    checkboxOptions: [
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.conflicting',
        searchValue: 'conflicting',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.conflicting',
          defaultMessage: 'Conflicting',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.decreasedResponse',
        searchValue: 'decreased response',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.decreasedResponse',
          defaultMessage: 'Decreased Response',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.noBenefit',
        searchValue: 'no benefit',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.noBenefit',
          defaultMessage: 'No Benefit',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.notApplicable',
        searchValue: 'not applicable',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.notApplicable',
          defaultMessage: 'Not Applicable',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.notPredictive',
        searchValue: 'not predictive',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.notPredictive',
          defaultMessage: 'Not Predictive',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.predictedResistant',
        searchValue: 'predicted - resistant',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.predictedResistant',
          defaultMessage: 'Predicted - Resistant',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.predictedSensitive',
        searchValue: 'predicted - sensitive',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.predictedSensitive',
          defaultMessage: 'Predicted - Sensitive',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.resistant',
        searchValue: 'resistant',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.resistant',
          defaultMessage: 'Resistant',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.sensitive',
        searchValue: 'sensitive',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.sensitive',
          defaultMessage: 'Sensitive',
        },
      },
      {
        id: 'jaxGeneDrugEvidence.filters.responseType.unknown',
        searchValue: 'unknown',
        intlLabel: {
          id: 'jaxGeneDrugEvidence.filters.responseType.unknown',
          defaultMessage: 'Unknown',
        },
      },
    ],
  },
};
